import { createAuthClient } from 'better-auth/react'
import { adminClient, emailOTPClient } from 'better-auth/client/plugins'
import { env } from './env'

export const authClient = createAuthClient({
  baseURL: env.apiUrl,
  basePath: '/auth',
  // adminClient exposes `stopImpersonating` and surfaces `session.impersonatedBy`
  // so the shell can show an impersonation banner when a Bocify admin is acting
  // as this partner.
  plugins: [emailOTPClient(), adminClient()],
  fetchOptions: { credentials: 'include' },
})
